// import Loader from 'common/components/Loader/Loader';
import AlertsContext from "providers/AlertProvider";
import useRouter from "common/hooks/use-router";
import useItem from "hooks/useItem";
import React, { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "hooks/useAuth";
import OrganizationForm from "./OrganizationForm";

function Organization() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "organizations",
    id,
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(
        currentUser?.isSuperadmin && !id ? "/organizations" : "/",
      );
    }
  }, [setAlert, router, error, currentUser, id, t]);

  const onSubmit = useCallback(
    async (dataOrganization: any) => {
      const newOrganization = { ...dataOrganization };

      try {
        if (newOrganization.data?.id) {
          await updateItem(newOrganization.data.id, newOrganization.data);
        } else {
          await saveItem(newOrganization);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem],
  );

  return isFetching || (id && !item) ? null : (
    <OrganizationForm onSubmit={onSubmit} item={item} />
  );
}

export default Organization;
